import { useState } from "react";

export default function ShareButtons({ title, url, excerpt }) {
  const [copied, setCopied] = useState(false);
  const link = url || (typeof window !== "undefined" ? window.location.href : "");
  const enc = encodeURIComponent;
  const text = `${title}${excerpt ? " — " + excerpt.slice(0, 120) : ""}`;

  const links = [
    { name: "WhatsApp", icon: "fa-brands fa-whatsapp", href: `https://wa.me/?text=${enc(text + " " + link)}` },
    { name: "LinkedIn", icon: "fa-brands fa-linkedin-in", href: `https://www.linkedin.com/sharing/share-offsite/?url=${enc(link)}` },
    { name: "X", icon: "fa-brands fa-x-twitter", href: `https://twitter.com/intent/tweet?text=${enc(text)}&url=${enc(link)}` },
    { name: "Facebook", icon: "fa-brands fa-facebook-f", href: `https://www.facebook.com/sharer/sharer.php?u=${enc(link)}` },
  ];

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(`${text} ${link}`);
      setCopied(true); setTimeout(() => setCopied(false), 1800);
    } catch {}
  };

  return (
    <div className="flex items-center gap-3 flex-wrap">
      <span className="eyebrow">Share</span>
      {links.map(l => (
        <a key={l.name} href={l.href} target="_blank" rel="noreferrer"
          data-testid={`share-${l.name.toLowerCase()}`}
          className="w-9 h-9 border hairline flex items-center justify-center text-[#2c2c2c] hover:border-[#0a1628] hover:bg-[#0a1628] hover:text-[#faf8f3] transition-colors">
          <i className={l.icon}></i>
        </a>
      ))}
      <button
        onClick={copy}
        data-testid="share-copy"
        className="w-9 h-9 border hairline flex items-center justify-center text-[#2c2c2c] hover:border-[#0a1628] hover:bg-[#0a1628] hover:text-[#faf8f3] transition-colors"
        aria-label="Copy link">
        <i className={`fa-solid ${copied ? "fa-check" : "fa-link"}`}></i>
      </button>
    </div>
  );
}
